<template>
  <div class="toolsPage">
    <div class="box">
      <h2>{{ $i18n.t('tools.bandwidthRequired') }}</h2>
      <div class="box-18">
        <div>{{ $i18n.t('tools.cameras') }}</div>
        <div><input v-model="form.camerasNumber" type="number"> <i></i></div>
      </div>
      <div class="box-item">
        <div>{{ $i18n.t('tools.codec') }}</div>
        <div>
          <el-radio-group v-model="form.encodingType" @change="calculate">
            <el-radio label="H.264"></el-radio>
            <el-radio label="H.265"></el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="box-18">
        <div>{{ $i18n.t('tools.videoResolution') }}</div>
        <div>
          <i></i>
          <el-select class="box-sele" v-model="form.videoResolution" @change="calculate">
            <!-- <el-option label="720p" value="720p"></el-option> -->
            <el-option label="1080p" value="1080p"></el-option>
            <el-option label="4MP" value="4MP"></el-option>
            <el-option label="5MP" value="5MP"></el-option>
            <el-option label="6MP" value="6MP"></el-option>
            <el-option label="4K" value="4K"></el-option>
          </el-select>
        </div>
      </div>
      <div class="box-18">
        <div>{{ $i18n.t('tools.frameRate') }}</div>
        <div>
          <i></i>
          <el-select class="box-sele" v-model="form.frameRate" @change="calculate">
            <el-option label="60fps" value="60"></el-option>
            <el-option label="50fps" value="50"></el-option>
            <el-option label="30fps" value="30"></el-option>
            <el-option label="25fps" value="25"></el-option>
            <el-option label="20fps" value="20"></el-option>
            <!-- <el-option label="19fps" value="19"></el-option>
            <el-option label="18fps" value="18"></el-option>
            <el-option label="17fps" value="17"></el-option>
            <el-option label="16fps" value="16"></el-option> -->
            <el-option label="15fps" value="15"></el-option>
            <!-- <el-option label="14fps" value="14"></el-option>
            <el-option label="13fps" value="13"></el-option>
            <el-option label="12fps" value="12"></el-option>
            <el-option label="11fps" value="11"></el-option> -->
            <el-option label="10fps" value="10"></el-option>
            <!-- <el-option label="9fps" value="9"></el-option>
            <el-option label="8fps" value="8"></el-option>
            <el-option label="7fps" value="7"></el-option>
            <el-option label="6fps" value="6"></el-option> -->
            <el-option label="5fps" value="5"></el-option>
            <!-- <el-option label="4fps" value="4"></el-option>
            <el-option label="3fps" value="3"></el-option>
            <el-option label="2fps" value="2"></el-option>
            <el-option label="1fps" value="1"></el-option> -->
          </el-select>
        </div>
      </div>
      <div class="box-item" v-if="isShow">
        <div>{{ $i18n.t("tools.superCoding") }}</div>
        <div>
          <el-radio-group v-model="form.superCoding" @change="changeEvent2">
            <el-radio label="No"></el-radio>
            <el-radio label="Yes"></el-radio>
          </el-radio-group>
        </div>
      </div>
      <!-- <div class="box-18" v-if="form.superCoding === 'Yes'">
        <div>Bit rate control mode</div>
        <div>
          <el-select class="box-sele" v-model="imageCompressionMode" @change="changeEvent1">
            <el-option label="Bit rate compression priority" :value="1"></el-option>
            <el-option label="Balanced" :value="2"></el-option>
            <el-option label="Image quality priority" :value="3"></el-option>
          </el-select>
        </div>
      </div> -->
      <div class="box-18">
        <div>{{ $i18n.t('tools.bitrate') }}</div>
        <div><input v-model="form.bitrate" disabled></div>
      </div>
      <div class="box_but">
        <button @click="calculate">{{ $i18n.t('tools.calculate') }}</button>
        <button @click="reset">{{ $i18n.t('tools.reset') }}</button>
      </div>

    </div>
    <div class="box-basao">
      <div><b>{{ $i18n.t('tools.result') }}</b><span>{{ $i18n.t('tools.forReferenceOnly') }}</span></div>
      <div><span>{{ $i18n.t('tools.bandwidthRequired') }}</span></div>
      <div>
        <span>{{ $i18n.t('tools.about') }}</span><b>{{form.results}}Mbit/s</b>
      </div>
      <!-- <div>
        <span>{{ $i18n.t('tools.viewFormula') }}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
// this.$i18n.t('navbar.about')
export default {
  data () {
    return {
      options: [{
        value: '选项1',
        label: '1080p'
      }, {
        value: '选项2',
        label: '4MP'
      }, {
        value: '选项3',
        label: '5MP'
      }, {
        value: '选项4',
        label: '6MP'
      }, {
        value: '选项5',
        label: '7MP'
      }, {
        value: '选项5',
        label: '4K'
      }
      ],
      value: '',
      form: {
        camerasNumber: 1, //摄像机数量
        encodingType: 'H.264', //编码类型
        videoResolution: null, //视频分辨率
        frameRate: '30', // 帧率
        superCoding: 'No',
        results: 0
      },
      constData: { // 满帧率主码流，以25fps为基准
        'H.264': {
          "720p": 2048,
          "1080p": 4096,
          "4MP": 6144,
          "5MP": 8192,
          "6MP": 10240,
          "4K": 12288
        },
        'H.265': {
          "720p": 1024,
          "1080p": 2048,
          "4MP": 4096,
          "5MP": 5120,
          "6MP": 6144,
          "4K": 8192
        },
      },
      imageCompressionMode: 2,
      compressionRate: {
        'H.264': {
          '720p': {
            1: 0.7,
            2: 0.8,
            3: 0.9
          },
          '1080p': {
            1: 0.65,
            2: 0.75,
            3: 0.85
          },
          '4MP': {
            1: 0.45,
            2: 0.55,
            3: 0.65
          },
          '5MP': {
            1: 0.4,
            2: 0.5,
            3: 0.6
          },
          '6MP': {
            1: 0.4,
            2: 0.5,
            3: 0.6
          },
          '4K': {
            1: 0.4,
            2: 0.5,
            3: 0.6
          },
        },
        'H.265': {
          '720p': {
            1: 0.7,
            2: 0.8,
            3: 0.9
          },
          '1080p': {
            1: 0.6,
            2: 0.7,
            3: 0.8
          },
          '4MP': {
            1: 0.4,
            2: 0.5,
            3: 0.6
          },
          '5MP': {
            1: 0.35,
            2: 0.45,
            3: 0.55
          },
          '6MP': {
            1: 0.35,
            2: 0.45,
            3: 0.55
          },
          '4K': {
            1: 0.35,
            2: 0.45,
            3: 0.55
          },
        }
      },
      isShow: true
    }
  },
  created () {
    // this.calculate()
  },
  mounted() {
    this.form.videoResolution = '1080p'
    this.calculate()
  },
  watch: {
    // 'form.videoResolution': {
    //   deep: true,
    //   handler(newValue, old) {
    //     if (newValue === '1080p') {
    //         this.form.superCoding = 'No'
    //         this.isShow = false
    //     } else {
    //       this.isShow = true
    //     }
    //   }
    // }
  },
  methods: {
    changeEvent1(value) {
      if (value) {
        this.calculate()
      }
    },
    changeEvent2(value) {
      if (value === 'No') {
        this.imageCompressionMode = 2
        this.calculate()
      } else {
        this.calculate()
      }
    },
    calculate () {
      this.form.bitrate = this.constData[this.form.encodingType][this.form.videoResolution] * Number(this.form.frameRate) / 25
      let result = this.form.camerasNumber * (this.form.bitrate / 1024);
      result = result.toFixed(2)
      if (this.form.superCoding === 'Yes') {
        if (this.imageCompressionMode) {
          let compressionRate = this.compressionRate[this.form.encodingType][this.form.videoResolution][this.imageCompressionMode]
          this.form.bitrate = (this.form.bitrate * compressionRate).toFixed(2)
          result = (this.form.camerasNumber * (this.form.bitrate / 1024)).toFixed(2)
        }
      }
      this.form.results = result
    },
    reset () {
      this.form = {
        camerasNumber: 1,
        encodingType: 'H.264',
        videoResolution: '1080p', 
        frameRate: '30',
        superCoding: 'No',
        results: 0
      }
      this.imageCompressionMode = 2
      this.calculate()
    },
  }
}
</script>

<style scoped lang="less">
/deep/ .el-input__inner {
  border: 1px solid #ebebeb;
}
select option {
  height: 100px !important;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.aaa {
  background: #f8f8f8;
  padding: 30px 0;
  min-height: inherit;
}
/deep/ .app-main[data-v-078753dd] {
  position: relative;
  overflow: hidden;
  min-height: 100%;
  flex: 1;
  background: #f8f8f8;
}
.tools {
  width: 1410px;
  margin: 0 auto;
  height: 100%;
  display: flex;

  .bread {
    margin-left: 5.5%;
    margin-top: 1%;
    margin-bottom: 1%;
    font-size: 15px;
  }

  .toolsClassify {
    width: 20%;
    overflow: hidden;
    height: 100%;
    float: left;
    // margin-left: 4%;
    background-color: #fff;
    border-radius: 5px;
    border-right: 1px solid #f1f1f1;
    .el-menu-item.is-active {
      background-color: red !important;
    }
  }

  .toolsPage {
    width: 98%;
    height: 100%;
    float: left;
    margin-left: 2%;
    background-color: #fff;
    border-radius: 5px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }
}

.el-menu-item {
  padding: 0;
}

a:hover {
  color: blue;
}

.menuClass {
  width: 100%;
  height: 100%;
  line-height: 78px;
  display: flex;
}
/deep/ .el-menu-item {
  width: 304px;
  height: 78px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
/deep/ .el-menu-item {
  padding-left: 30px !important;
  display: flex;
}
.icon_img {
  margin: 28px 0;
  height: 48px;
  line-height: 24px;
  margin-right: 10px;
}
.menuClass_box {
  width: 220px;
  height: 48px;
  margin: 28px 0;
  font-size: 18px;

  font-weight: 400;
  color: #333333;
  white-space: normal;
  line-height: 24px;
}
span {
  font-weight: 400;
}
label {
  margin-bottom: 18px;
}
label span {
  font-size: 16px;

  font-weight: 400;
  color: #333333;
  line-height: 19px;
  margin-right: 44px;
  margin-left: 5px;
}
.box {
  width: 66%;
  padding-left: 62px;
  font-size: 16px;

  font-weight: 400;
  color: #666666;
  line-height: 19px;
  h2 {
    // margin-top: 20px;
    margin-bottom: 50px;
    font-size: 22px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 26px;
  }
}
.box-18 {
  margin-top: 18px;
  input {
    padding-left: 20px;
    width: 602px;
    height: 36px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #e7e7e7;
    margin-top: 5px;
    outline: none;
  }
  .box-inps {
    width: 82px;
    height: 36px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #e7e7e7;
  }
}
.box-sele {
  outline: none;
  width: 602px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  // border: 1px solid #e7e7e7;
  margin-top: 5px;
}
.box-item {
  margin-top: 18px;
  display: flex;
  div:nth-of-type(1) {
    width: 220px;
    font-size: 16px;

    font-weight: 400;
    color: #666666;
    line-height: 19px;
    // margin-right: 138px;
  }
}
.box-basao {
  width: 340px;
  height: 290px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  border: 1px solid #e7e7e7;
  padding-left: 30px;
  margin-right: 20px;
}
.box-basao div:nth-of-type(1) {
  margin: 20px 0;
  b {
    font-size: 22px;

    font-weight: 400;
    color: #000000;
    line-height: 26px;
  }
  span {
    font-size: 12px;

    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
}
.box-basao div:nth-of-type(2) {
  padding: 20px 0;
  border-top: 1px solid #f1f1f1;
  span {
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 23px;
  }
}
.box-basao div:nth-of-type(3) {
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  span {
    font-size: 16px;

    font-weight: 400;
    color: #c7000b;
    line-height: 19px;
  }
  b {
    font-size: 40px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #c7000b;
    line-height: 47px;
  }
}
.box-basao div:nth-of-type(4) {
  margin: 20px 0;
  span {
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 23px;
  }
}
.box-basao div:nth-of-type(5) {
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  span {
    font-size: 16px;

    font-weight: 400;
    color: #c7000b;
    line-height: 19px;
  }
  b {
    font-size: 40px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #c7000b;
    line-height: 47px;
  }
}
.box-basao div:nth-of-type(6) {
  padding: 20px 0;
  border-top: 1px solid #f1f1f1;
  span {
    font-size: 16px;

    font-weight: 400;
    color: #333333;
    line-height: 19px;
  }
}

.box_but {
  margin-top: 60px;
  margin-bottom: 50px;
  button:nth-of-type(1) {
    width: 140px;
    height: 50px;
    background: #c7000b;
    color: #fff;
    border-radius: 54px 54px 54px 54px;
    border: 0;
    opacity: 1;
    margin-right: 20px;
  }
  button:nth-of-type(2) {
    width: 140px;
    height: 50px;
    background: #fff;
    color: #c7000b;
    border-radius: 54px 54px 54px 54px;
    border: 1px solid #c7000b;
    opacity: 1;
  }
}
.box-img {
  width: 100%;
  height: 500px;
  margin-top: 60px;
  margin-bottom: 40px;
  padding-left: 62px;
  span {
    font-size: 22px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 26px;
    margin-bottom: 30px;
  }
  img {
    width: 769px;
    height: 423px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
}
.toolsPa {
  width: 78%;
  // height: 1259px;
  // float: left;
  margin-left: 2%;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
input[type='radio']:checked {
  // background: #c7000b !important;
  // border: 1px solid #c7000b !important;
  // background: url('../../../assets/image/tools/Group 142.png');
}
input[type='radio'].radio {
  opacity: 0;
  display: inline-block;
  height: 20px;
}
label.radio {
  background: #000000;
  background: url(../../../assets/image/tools/Group142.png) no-repeat;
  height: 20px;
  padding-left: 25px;
}
input[type='radio'].radio:checked + .radio {
  background: url(../../../assets/image/tools/Group142.png) no-repeat;
}
.yy {
  position: relative;
}
.yyy {
  margin-left: 5px;
}
.yyys {
  padding: 19px;
  display: none;
  position: absolute;
  right: 47px;
  top: 5px;
  width: 372px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 1px rgba(123, 123, 123, 0.27);
  border-radius: 8px 0px 8px 8px;
  opacity: 1;
}
.yyy:hover .yyys {
  display: block;
}
</style>
